import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateOptionalTime: any;
  DateOptionalTimeRange: any;
  DateTime: any;
  Email: any;
  File: any;
  ImageFile: any;
  JSON: any;
  Mixed: any;
  VideoFile: any;
};

/**
 * The AdvertiserAccount type represents the client account of an external company that has an advertising agreement with
 * Aleph. This is almost always a company such as Wolt, Coca Cola, Trading 212, ...
 */
export type AdvertiserAccount = {
  __typename?: 'AdvertiserAccount';
  /** A subquery that shows which user groups have access to this advertiser on which apps. */
  advertiserAccountAccess?: Maybe<Array<Maybe<AdvertiserAccountAccess>>>;
  /** Datetime of when the advertiser account was created. */
  advertiserAccountCreatedAt: Scalars['DateTime'];
  advertiserAccountId: Scalars['ID'];
  /** The name of the advertiser. */
  advertiserAccountName: Scalars['String'];
  /** URL for the advertiser's profile picture. */
  advertiserAccountProfilePicture?: Maybe<Scalars['String']>;
  /** The User that owns the advertiser account. */
  owner: User;
};


/**
 * The AdvertiserAccount type represents the client account of an external company that has an advertising agreement with
 * Aleph. This is almost always a company such as Wolt, Coca Cola, Trading 212, ...
 */
export type AdvertiserAccountAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<AdvertiserAccountAccessOrderBy>;
};

/**
 * The advertiserAccountAccess type represents the permission of a
 * user group to access an advertiser account on a certain app.
 */
export type AdvertiserAccountAccess = {
  __typename?: 'AdvertiserAccountAccess';
  advertiserAccount?: Maybe<AdvertiserAccount>;
  advertiserAccountAccessCreatedAt?: Maybe<Scalars['DateTime']>;
  app?: Maybe<App>;
  userGroup?: Maybe<UserGroup>;
};

export type AdvertiserAccountAccessCursored = {
  __typename?: 'AdvertiserAccountAccessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdvertiserAccountAccess>>;
};

export type AdvertiserAccountAccessFilters = {
  /** Filter by advertiser account ID. */
  advertiserAccountId?: InputMaybe<Array<IdFilter>>;
  /** Filter by app ID. */
  appId?: InputMaybe<Array<IdFilter>>;
  /** Filter by user group ID. */
  userGroupId?: InputMaybe<Array<IdFilter>>;
};

export type AdvertiserAccountAccessOrderBy = {
  column: AdvertiserAccountAccessOrderByColumn;
  direction?: OrderByDirection;
};

export type AdvertiserAccountFilters = {
  /** Filter by the advertiser account's ID. */
  advertiserAccountId?: InputMaybe<Array<IdFilter>>;
  /** Filter by the advertiser account's name. */
  advertiserAccountName?: InputMaybe<Array<StringFilter>>;
  /** Filter by the user ID of the advertiser account's owner. */
  advertiserAccountOwnerId?: InputMaybe<Array<IdFilter>>;
};

export type AdvertiserAccountOrderBy = {
  column: AdvertiserAccountOrderByColumn;
  direction?: OrderByDirection;
};

export enum AdvertiserAccountOrderByColumn {
  AdvertiserAccountCreatedAt = 'advertiserAccountCreatedAt',
  AdvertiserAccountId = 'advertiserAccountId',
  AdvertiserAccountName = 'advertiserAccountName'
}

export type AdvertiserAccountsCursored = {
  __typename?: 'AdvertiserAccountsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<AdvertiserAccount>>;
};

export type App = {
  __typename?: 'App';
  advertiserAccountAccess?: Maybe<Array<AdvertiserAccountAccess>>;
  appCreatedAt: Scalars['DateTime'];
  appId: Scalars['ID'];
  appName?: Maybe<Scalars['String']>;
};


export type AppAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<AdvertiserAccountAccessOrderBy>;
};

export type AppFilters = {
  appId?: InputMaybe<Array<IdFilter>>;
  appName?: InputMaybe<Array<StringFilter>>;
};

export type AppOrderBy = {
  column: AppOrderByColumn;
  direction?: OrderByDirection;
};

export enum AppOrderByColumn {
  AppCreatedAt = 'appCreatedAt',
  AppId = 'appId',
  AppName = 'appName'
}

export type AppsCursored = {
  __typename?: 'AppsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<App>>;
};

export type BooleanFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Boolean'];
};

export type BooleanRealmFilter = {
  value: Scalars['Boolean'];
};

export type Credential = {
  __typename?: 'Credential';
  credentialCreatedAt: Scalars['DateTime'];
  credentialId: Scalars['ID'];
  credentialName: Scalars['String'];
};

export type CredentialFilter = {
  credentialId?: InputMaybe<Array<IdFilter>>;
  credentialName?: InputMaybe<Array<StringFilter>>;
};

export type CredentialOrderBy = {
  column: CredentialOrderByColumn;
  direction?: OrderByDirection;
};

export enum CredentialOrderByColumn {
  CredentialCreatedAt = 'credentialCreatedAt',
  CredentialId = 'credentialId',
  CredentialName = 'credentialName'
}

export type CredentialsCursored = {
  __typename?: 'CredentialsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Credential>>;
};

export type DateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['DateOptionalTime']>;
};

export type DateRangeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTimeRange'];
};

export type ExactStringFilter = {
  value: Scalars['String'];
};

export type FloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Float']>;
};

export type IdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['ID']>;
};

export type IdRealmFilter = {
  value: Array<Scalars['ID']>;
};

export type IntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Add a user to a user group directly. This can only be done by a platform admin. */
  addUserToUserGroup: UserGroupAccess;
  /** Assign a credential to a user. Returns a list of the user's credentials. */
  assignCredential: Array<Credential>;
  /** Assign a credentials to a user. Returns a list of the user's credentials. */
  assignCredentials: Array<Credential>;
  /**
   * Assign a credentials to a user based on the WBN platform and user role. Returns a list of the user's credentials.
   * NOTE: this endpoint should only be used on a freshly created user
   */
  assignCredentialsForWBNPlatformAndAccountRole: Array<Credential>;
  /** Create an advertiser account. */
  createAdvertiserAccount: AdvertiserAccount;
  /** Create a credential that can then be assigned to a user. */
  createCredential: Credential;
  createUser: User;
  /**  Create a new user group with a given name.  */
  createUserGroup: UserGroup;
  /** Delete a credential. Credentials that are assigned to any users cannot be deleted. */
  deleteCredential: Scalars['Boolean'];
  /**  Delete a user group.  */
  deleteUserGroup?: Maybe<Scalars['Boolean']>;
  /** Grant a user group access to an advertiser account on a specific app. */
  grantAdvertiserAccountAccess: AdvertiserAccountAccess;
  /**
   * Remove a user from a user group. This can only be done by an admin or the owner of a user group,
   * unless a user wants to remove themselves, which has no restrictions.
   * An owner cannot remove themself from a user group,
   * but must first transfer the ownership via transferUserGroupOwnership.
   */
  removeUserFromUserGroup: Scalars['Boolean'];
  /** Revoke a user group's access to an advertiser account on a specific app. */
  revokeAdvertiserAccountAccess: Scalars['Boolean'];
  /** Revoke a credential from a user. Returns a list of the user's credentials. */
  revokeCredential: Array<Credential>;
  /**
   * Make another user the new owner of a user group. The new owner must be an existing user in the user group.
   * The user making the request must be the current owner of the user group, who then becomes an admin.
   */
  transferUserGroupOwnership: UserGroupAccess;
  /** Update an existing advertiser account. Can only be done by a platform admin or the owner of the advertiser account. */
  updateAdvertiserAccount: AdvertiserAccount;
  updateMe: User;
  updateUser: User;
  /**  Update a user group.  */
  updateUserGroup: UserGroup;
  /**
   * Update a user's role in a user group. This can only be done by an admin or the owner of a user group.
   * A user can only be changed to a member or admin role.
   * The OWNER role must be transfer via the "transferUserGroupOwnership" mutation.
   */
  updateUserRoleInUserGroup: UserGroupAccess;
  version?: Maybe<Scalars['String']>;
};


export type MutationAddUserToUserGroupArgs = {
  userGroupAccessRole: UserGroupAccessRole;
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignCredentialArgs = {
  credentialId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationAssignCredentialsArgs = {
  credentialIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};


export type MutationAssignCredentialsForWbnPlatformAndAccountRoleArgs = {
  WBNPlatform?: InputMaybe<WbnPlatform>;
  userId: Scalars['ID'];
};


export type MutationCreateAdvertiserAccountArgs = {
  advertiserAccountName: Scalars['String'];
  advertiserAccountOwnerId: Scalars['ID'];
  advertiserAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationCreateCredentialArgs = {
  credentialName: Scalars['String'];
};


export type MutationCreateUserArgs = {
  userAccountLevel: UserAccountLevel;
  userEmail: Scalars['String'];
  userName: Scalars['String'];
  userPassword: Scalars['String'];
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname: Scalars['String'];
};


export type MutationCreateUserGroupArgs = {
  userGroupName: Scalars['String'];
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationDeleteCredentialArgs = {
  credentialId: Scalars['ID'];
};


export type MutationDeleteUserGroupArgs = {
  userGroupId: Scalars['ID'];
};


export type MutationGrantAdvertiserAccountAccessArgs = {
  advertiserAccountId: Scalars['ID'];
  appId: Scalars['ID'];
  userGroupId: Scalars['ID'];
};


export type MutationRemoveUserFromUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationRevokeAdvertiserAccountAccessArgs = {
  advertiserAccountId: Scalars['ID'];
  appId: Scalars['ID'];
  userGroupId: Scalars['ID'];
};


export type MutationRevokeCredentialArgs = {
  credentialId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationTransferUserGroupOwnershipArgs = {
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type MutationUpdateAdvertiserAccountArgs = {
  advertiserAccountId: Scalars['ID'];
  advertiserAccountName?: InputMaybe<Scalars['String']>;
  advertiserAccountOwnerId?: InputMaybe<Scalars['ID']>;
  advertiserAccountProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationUpdateMeArgs = {
  userEmail?: InputMaybe<Scalars['String']>;
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserArgs = {
  userAccountLevel?: InputMaybe<UserAccountLevel>;
  userEmail?: InputMaybe<Scalars['String']>;
  userId: Scalars['ID'];
  userName?: InputMaybe<Scalars['String']>;
  userPassword?: InputMaybe<Scalars['String']>;
  userProfilePicture?: InputMaybe<Scalars['ImageFile']>;
  userSurname?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateUserGroupArgs = {
  userGroupId: Scalars['ID'];
  userGroupName: Scalars['String'];
  userGroupProfilePicture?: InputMaybe<Scalars['ImageFile']>;
};


export type MutationUpdateUserRoleInUserGroupArgs = {
  userGroupAccessRole: UserGroupAccessRole;
  userGroupId: Scalars['ID'];
  userId: Scalars['ID'];
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type Query = {
  __typename?: 'Query';
  /** List advertiser account group accesses. */
  advertiserAccountAccess: AdvertiserAccountAccessCursored;
  /** A list of advertiser accounts that the user has access to. */
  advertiserAccounts: AdvertiserAccountsCursored;
  apps?: Maybe<AppsCursored>;
  credentials: CredentialsCursored;
  me: User;
  /** Get a list of accesses to user groups. */
  userGroupAccess: UserGroupAccessCursored;
  userGroups: UserGroupsCursored;
  users: UsersCursored;
  version?: Maybe<Scalars['String']>;
};


export type QueryAdvertiserAccountAccessArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertiserAccountAccessOrderBy>>;
};


export type QueryAdvertiserAccountsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AdvertiserAccountFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AdvertiserAccountOrderBy>>;
};


export type QueryAppsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<AppFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<AppOrderBy>>;
};


export type QueryCredentialsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<CredentialFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<InputMaybe<CredentialOrderBy>>>;
  query?: InputMaybe<Scalars['String']>;
};


export type QueryUserGroupAccessArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserGroupAccessFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};


export type QueryUserGroupsArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserGroupFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserGroupOrderBy>>;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<UserFilters>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<UserOrderBy>>;
};

export type SingleDateFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['DateOptionalTime'];
};

export type SingleDateRealmFilter = {
  value: Scalars['DateTime'];
};

export type SingleFloatFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Float'];
};

export type SingleFloatRealmFilter = {
  value: Scalars['Float'];
};

export type SingleIdFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['ID'];
};

export type SingleIdRealmFilter = {
  value: Scalars['ID'];
};

export type SingleIntFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['Int'];
};

export type SingleIntRealmFilter = {
  value: Scalars['Int'];
};

export type SingleStringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type SingleStringRealmFilter = {
  value: Scalars['String'];
};

export type StringFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<Scalars['String']>;
  wildcard?: InputMaybe<Scalars['Boolean']>;
};

export type StringRealmFilter = {
  value: Array<Scalars['String']>;
};

/** A user represents a person that can authenticate with the global auth system. */
export type User = {
  __typename?: 'User';
  credentials?: Maybe<Array<Credential>>;
  userAccountLevel: UserAccountLevel;
  userCreatedAt: Scalars['DateTime'];
  userEmail: Scalars['String'];
  userGroupAccess?: Maybe<Array<UserGroupAccess>>;
  userId: Scalars['ID'];
  userName: Scalars['String'];
  userProfilePictureUrl?: Maybe<Scalars['String']>;
  userSurname: Scalars['String'];
  userTwoFactorAuthenticationEnabled: Scalars['Boolean'];
};


/** A user represents a person that can authenticate with the global auth system. */
export type UserCredentialsArgs = {
  filters?: InputMaybe<CredentialFilter>;
  orderBy?: InputMaybe<Array<CredentialOrderBy>>;
};


/** A user represents a person that can authenticate with the global auth system. */
export type UserUserGroupAccessArgs = {
  filters?: InputMaybe<UserGroupAccessFilters>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};

export enum UserAccountLevel {
  AdvertiserAdmin = 'ADVERTISER_ADMIN',
  AgencyAdmin = 'AGENCY_ADMIN',
  PlatformAdmin = 'PLATFORM_ADMIN',
  User = 'USER'
}

export type UserAccountLevelFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: UserAccountLevel;
};

export type UserFilters = {
  userAccountLevel?: InputMaybe<Array<UserAccountLevelFilter>>;
  userEmail?: InputMaybe<Array<StringFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
  userName?: InputMaybe<Array<StringFilter>>;
  userSurname?: InputMaybe<Array<StringFilter>>;
  userTwoFactorAuthenticationEnabled?: InputMaybe<Array<BooleanFilter>>;
};

/** A user group is a collection of users. It may also be one user. */
export type UserGroup = {
  __typename?: 'UserGroup';
  /**  A subquery for all advertiser accounts that the user group has access to, and on which app.  */
  advertiserAccountAccess?: Maybe<Array<AdvertiserAccountAccess>>;
  /**  A subquery for all users that have access to the user group, and at which level.  */
  userGroupAccess?: Maybe<Array<UserGroupAccess>>;
  /**  The date and time the user group was created at.  */
  userGroupCreatedAt: Scalars['DateTime'];
  /**  The ID of the user group.  */
  userGroupId: Scalars['ID'];
  /**  The name of the user group.  */
  userGroupName: Scalars['String'];
  /**  The type of the user group.  */
  userGroupType: UserGroupType;
};


/** A user group is a collection of users. It may also be one user. */
export type UserGroupAdvertiserAccountAccessArgs = {
  filters?: InputMaybe<AdvertiserAccountAccessFilters>;
  orderBy?: InputMaybe<Array<InputMaybe<AdvertiserAccountAccessOrderBy>>>;
};


/** A user group is a collection of users. It may also be one user. */
export type UserGroupUserGroupAccessArgs = {
  filters?: InputMaybe<UserGroupAccessFilters>;
  orderBy?: InputMaybe<Array<UserGroupAccessOrderBy>>;
};

export type UserGroupAccess = {
  __typename?: 'UserGroupAccess';
  /** The user that has access. */
  user: User;
  /** The user group that the user has access to. */
  userGroup: UserGroup;
  /** The time that the access was first granted. */
  userGroupAccessCreatedAt: Scalars['DateTime'];
  /** The user's role in the user group. */
  userGroupAccessRole: UserGroupAccessRole;
};

export type UserGroupAccessCursored = {
  __typename?: 'UserGroupAccessCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<UserGroupAccess>>;
};

export type UserGroupAccessFilters = {
  userGroupAccessRole?: InputMaybe<Array<UserGroupAccessRoleFilter>>;
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type UserGroupAccessOrderBy = {
  column: UserGroupAccessOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserGroupAccessOrderByColumn {
  UserGroupAccessCreatedAt = 'userGroupAccessCreatedAt',
  UserGroupAccessRole = 'userGroupAccessRole'
}

/** Represents the role that a user has in a user group. */
export enum UserGroupAccessRole {
  /** An admin of a user group, granting them special administrative privileges. */
  Admin = 'ADMIN',
  /** A member of a user group. */
  Member = 'MEMBER',
  /** The owner of a user group. Only one can exist at any moment. */
  Owner = 'OWNER'
}

export type UserGroupAccessRoleFilter = {
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserGroupAccessRole>;
};

export type UserGroupFilter = {
  userGroupId?: InputMaybe<Array<IdFilter>>;
  userGroupName?: InputMaybe<Array<StringFilter>>;
  userGroupOwnerEmail?: InputMaybe<Array<StringFilter>>;
  userGroupType?: InputMaybe<Array<UserGroupTypeFilter>>;
  userId?: InputMaybe<Array<IdFilter>>;
};

export type UserGroupOrderBy = {
  column: UserGroupOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserGroupOrderByColumn {
  UserGroupCreatedAt = 'userGroupCreatedAt',
  UserGroupId = 'userGroupId',
  UserGroupName = 'userGroupName',
  UserGroupType = 'userGroupType'
}

export enum UserGroupType {
  /**  A PRIVATE user group belongs to, and contains, only one user.  */
  Private = 'PRIVATE',
  /**  A PUBLIC user group contains multiple users.  */
  Public = 'PUBLIC'
}

export type UserGroupTypeFilter = {
  acceptNull?: InputMaybe<Scalars['Boolean']>;
  exclude?: InputMaybe<Scalars['Boolean']>;
  value: Array<UserGroupType>;
};

export type UserGroupsCursored = {
  __typename?: 'UserGroupsCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<UserGroup>>;
};

export type UserOrderBy = {
  column: UserOrderByColumn;
  direction?: OrderByDirection;
};

export enum UserOrderByColumn {
  UserAccountLevel = 'userAccountLevel',
  UserCreatedAt = 'userCreatedAt',
  UserEmail = 'userEmail',
  UserId = 'userId',
  UserName = 'userName',
  UserSurname = 'userSurname',
  UserTwoFactorAuthenticationEnabled = 'userTwoFactorAuthenticationEnabled'
}

export type UsersCursored = {
  __typename?: 'UsersCursored';
  cursor?: Maybe<Scalars['String']>;
  items?: Maybe<Array<User>>;
};

export enum WbnPlatform {
  Facebook = 'FACEBOOK',
  Reddit = 'REDDIT',
  Spotify = 'SPOTIFY',
  Tiktok = 'TIKTOK',
  X = 'X'
}

export enum AdvertiserAccountAccessOrderByColumn {
  AdvertiserAccountAccessCreatedAt = 'advertiserAccountAccessCreatedAt'
}



export type AuthGraphUserMetaDataQueryVariables = Exact<{ [key: string]: never; }>;

export type AuthGraphUserMetaDataQueryUserCredential = {
	__typename?: 'Credential',
	credentialId: string,
	credentialName: string 
}

export type AuthGraphUserMetaDataQueryMe = {
	__typename?: 'User',
	userId: string,
	userEmail: string,
	userName: string,
	userSurname: string,
	userAccountLevel: UserAccountLevel,
	userProfilePictureUrl?: string | null,
	userTwoFactorAuthenticationEnabled: boolean,
	userCreatedAt: any,
	userCredential?: Array<AuthGraphUserMetaDataQueryUserCredential> | null 
}

export type AuthGraphUserMetaDataQuery = {
	__typename?: 'Query',
	me: AuthGraphUserMetaDataQueryMe 
};

export type AuthGraphRevokeUserFromGroupMutationVariables = Exact<{

  userId: Scalars['ID'];

  userGroupId: Scalars['ID'];

}>;

export type AuthGraphRevokeUserFromGroupMutation = {
	__typename?: 'Mutation',
	removeUserFromUserGroup: boolean 
};

export type AuthGraphAssignCredentialsMutationVariables = Exact<{

  userId: Scalars['ID'];

  WBNPlatform?: InputMaybe<WbnPlatform>;

}>;

export type AuthGraphAssignCredentialsMutationAssignCredentialsForWBNPlatformAndAccountRole = {
	__typename?: 'Credential',
	credentialId: string,
	credentialName: string,
	credentialCreatedAt: any 
}

export type AuthGraphAssignCredentialsMutation = {
	__typename?: 'Mutation',
	assignCredentialsForWBNPlatformAndAccountRole: Array<AuthGraphAssignCredentialsMutationAssignCredentialsForWBNPlatformAndAccountRole> 
};

export type AuthGraphGroupsForUsersQueryVariables = Exact<{

  search: Scalars['String'];

  selectedIds: Array<Scalars['ID']> | Scalars['ID'];

  userId?: InputMaybe<Array<IdFilter> | IdFilter>;

}>;

export type AuthGraphGroupsForUsersQueryUser = {
	__typename?: 'User',
	userId: string,
	id: string 
}

export type AuthGraphGroupsForUsersQueryUserGroupAccess = {
	__typename?: 'UserGroupAccess',
	userGroupAccessRole: UserGroupAccessRole,
	user: AuthGraphGroupsForUsersQueryUser 
}

export type AuthGraphGroupsForUsersQueryItems = {
	__typename?: 'UserGroup',
	id: string,
	value: string,
	label: string,
	userGroupAccess?: Array<AuthGraphGroupsForUsersQueryUserGroupAccess> | null 
}

export type AuthGraphGroupsForUsersQueryUserGroups = {
	__typename?: 'UserGroupsCursored',
	items?: Array<AuthGraphGroupsForUsersQueryItems> | null 
}

export type AuthGraphGroupsForUsersQuery = {
	__typename?: 'Query',
	userGroups: AuthGraphGroupsForUsersQueryUserGroups 
};

export const AuthGraphUserMetaDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphUserMetaData"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"me"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"userEmail"}},{"kind":"Field","name":{"kind":"Name","value":"userName"}},{"kind":"Field","name":{"kind":"Name","value":"userSurname"}},{"kind":"Field","name":{"kind":"Name","value":"userAccountLevel"}},{"kind":"Field","name":{"kind":"Name","value":"userProfilePictureUrl"}},{"kind":"Field","name":{"kind":"Name","value":"userTwoFactorAuthenticationEnabled"}},{"kind":"Field","name":{"kind":"Name","value":"userCreatedAt"}},{"kind":"Field","alias":{"kind":"Name","value":"userCredential"},"name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialId"}},{"kind":"Field","name":{"kind":"Name","value":"credentialName"}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphUserMetaDataQuery, AuthGraphUserMetaDataQueryVariables>;
export const AuthGraphRevokeUserFromGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphRevokeUserFromGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeUserFromUserGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userGroupId"}}}]}]}}]} as unknown as DocumentNode<AuthGraphRevokeUserFromGroupMutation, AuthGraphRevokeUserFromGroupMutationVariables>;
export const AuthGraphAssignCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"authGraphAssignCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"WBNPlatform"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"WBNPlatform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assignCredentialsForWBNPlatformAndAccountRole"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"WBNPlatform"},"value":{"kind":"Variable","name":{"kind":"Name","value":"WBNPlatform"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentialId"}},{"kind":"Field","name":{"kind":"Name","value":"credentialName"}},{"kind":"Field","name":{"kind":"Name","value":"credentialCreatedAt"}}]}}]}}]} as unknown as DocumentNode<AuthGraphAssignCredentialsMutation, AuthGraphAssignCredentialsMutationVariables>;
export const AuthGraphGroupsForUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"authGraphGroupsForUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"IdFilter"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filters"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupName"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"ListValue","values":[{"kind":"Variable","name":{"kind":"Name","value":"search"}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"wildcard"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userGroupId"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"selectedIds"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"exclude"},"value":{"kind":"BooleanValue","value":true}}]}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"value"},"name":{"kind":"Name","value":"userGroupId"}},{"kind":"Field","alias":{"kind":"Name","value":"label"},"name":{"kind":"Name","value":"userGroupName"}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccess"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userGroupAccessRole"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AuthGraphGroupsForUsersQuery, AuthGraphGroupsForUsersQueryVariables>;